import declare from "dojo/_base/declare";
import locale from "csi/locale";
import MessageDialog from "csi/widget/MessageDialog";
import util from "csi/util";
import PostRequestController from "csi/action/PostRequestController";

const SYNC_PARAMETERS_SUCCESS_MESSAGE = "SyncParametersSuccessMessage";
const SYNC_PARAMETERS_SUCCESS_MESSAGE_TITLE = "SyncParametersSuccessMessageTitle";
const SYNC_PARAMETERS_TT_MESSAGE = "SyncParameters_TT";
const SyncParametersController = declare(PostRequestController, {

	bShowProgress: true,

	/** @property {Number} nStatusLoadingMinDelay - minimum time the loading popup needs to remain open in milliseconds */
	nStatusLoadingMinDelay: 1000,

	/** @property {Number} _nStatusLoadingStart - time when loading popup was created in milliseconds */
	_nStatusLoadingStart: null,

	/**
	 * Wait until loading popup has been open for the minimum amount of time
	 */
	async waitForLoadPopup() {
		const loadingTime = Date.now() - this._nStatusLoadingStart;
		const remainingTime = Math.max(this.nStatusLoadingMinDelay - loadingTime, 0);

		await util.wait(remainingTime);
	},

	/**
	 * @override
     * Add Action name to Display.
     * @param {Object} params
     */
	confirmAction: function(params) {
		params = params || {};
		params.title =  locale.resource(SYNC_PARAMETERS_TT_MESSAGE);
		this.inherited(arguments);
	},

	/**
	 * @override
	 * Display progress dialog when action is performed
	 */
	waitForPublish() {
		this._nStatusLoadingStart = Date.now();
		this.inherited(arguments);
	},

	/**
	 * @override
	 * Display error dialog if operation has error
	 * @param err 
	 */
	async _onPublishError(/*Error*/err) {
		await this.waitForLoadPopup();
		this.publishError(err);
	},

	/**
	 * @override 
	 * Add success message based on operation response values
	 */
	postProcessSuccess() {
		const res = this.m_response.getReturnValue();
		const resJson = JSON.parse(res);
		new MessageDialog({
			buttons: [MessageDialog.BUTTON_OK],
			materialIcon: MessageDialog.ICON_COMPLETED,
			message: locale.resource(SYNC_PARAMETERS_SUCCESS_MESSAGE, [resJson.nodesLinkedCount, resJson.nodesDeletedCount]),
			title: locale.resource(SYNC_PARAMETERS_SUCCESS_MESSAGE_TITLE),
		}).show();
	},
});

export = SyncParametersController;